import React, { useState } from 'react';

/**
 * A password <input> with a show/hide toggle button. Self-contained (no
 * external CSS required) so it drops into any form: pass `leftIcon` +
 * `wrapperClassName="input-icon-wrapper"` + `className="form-control"` to
 * match the auth pages' existing look, or omit them for a plain input like
 * team member forms use.
 */
const PasswordInput = ({
  leftIcon = null,
  wrapperClassName = '',
  className = '',
  style,
  ...inputProps
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <div className={wrapperClassName} style={{ position: 'relative' }}>
      {leftIcon && <i className={`${leftIcon} input-icon`}></i>}
      <input
        {...inputProps}
        type={visible ? 'text' : 'password'}
        className={className}
        style={{ paddingRight: '2.75rem', ...style }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Hide password' : 'Show password'}
        style={{
          position: 'absolute',
          right: '0.75rem',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'none',
          border: 'none',
          color: '#9ca3af',
          cursor: 'pointer',
          padding: '0.25rem',
          display: 'flex',
          alignItems: 'center',
          fontSize: '0.95rem',
        }}
      >
        <i className={`fas ${visible ? 'fa-eye-slash' : 'fa-eye'}`}></i>
      </button>
    </div>
  );
};

export default PasswordInput;
